
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { breakpoint } from '~/composables/breakpoint';

export default defineComponent({
  name: 'AppBaseCard',
  props: {
    index: {
      type: Number,
      default: null,
    },
    cut: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { isBiggerThanBreakpoint } = breakpoint('lg');
    const variants = {
      red: [
        {
          static: {
            position: '-bottom-[90%] -left-[92%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: '-bottom-[120%] -left-[63%] h-[200%] w-[150%]',
                mobile: '-top-[55%] -left-[61%] h-[100%] w-[125%]',
              },
              color: 'bg-radial-ellipse-pink',
            },
            {
              position: {
                desktop: '-bottom-[13%] left-[18%] h-[149%] w-[86%]',
                mobile: '-bottom-[48%] -left-[23%] h-[106%] w-[94%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: '-right-[18%] -bottom-[89%] h-[152%] w-[75%]',
                mobile: '-right-[49%] -bottom-[85%] h-[183%] w-[125%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: 'bottom-[22%] -right-[38%] h-[148%] w-[73%]',
                mobile: 'bottom-[22%] -right-[38%] h-[148%] w-[73%]',
              },
              color: 'bg-radial-ellipse-red',
            },
          ],
        },
        {
          static: {
            position: '-bottom-[90%] -left-[22%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: 'top-[2%] -left-[63%] h-[200%] w-[150%]',
                mobile: '-top-[36%] -right-[66%] h-[136%] w-[113%]',
              },
              color: 'bg-radial-ellipse-pink',
            },
            {
              position: {
                desktop: 'left-[15%] -bottom-[25%] h-[87%] w-[53%]',
                mobile: '-right-[20%] -bottom-[10%] h-[87%] w-[87%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: 'left-[3%] bottom-[16%] h-[178%] w-[100%]',
                mobile: '-right-[30%] -bottom-[71%] h-[138%] w-[159%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: '-bottom-[62%] -right-[47%] h-[174%] w-[119%]',
                mobile: '-bottom-[91%] -left-[94%] h-[124%] w-[135%]',
              },
              color: 'bg-radial-ellipse-red',
            },
          ],
        },
        {
          static: {
            position: '-bottom-[40%] -left-[32%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: '-top-[21%] -right-[19.5%] h-[131%] w-[85%]',
                mobile: 'top-[5%] -left-[56%] h-[100%] w-[118%]',
              },
              color: 'bg-radial-ellipse-pink',
            },
            {
              position: {
                desktop: 'left-[13%] -top-[14%] h-[115%] w-[66%]',
                mobile: '-right-[148%] -top-[99%] h-[150%] w-[200%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: '-left-[22%] -bottom-[69%] h-[135%] w-[72%]',
                mobile: '-left-[63%] -bottom-[71%] h-[103%] w-[117%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: 'top-[34%] -right-[1%] h-[157%] w-[79%]',
                mobile: 'top-[13%] -right-[68%] h-[157%] w-[155%]',
              },
              color: 'bg-radial-ellipse-red',
            },
          ],
        },
        {
          static: {
            position: '-bottom-[90%] -left-[92%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: '-bottom-[34%] -left-[17%] h-[110%] w-[77%]',
                mobile: 'top-[18%] -left-[28%] h-[109%] w-[200%]',
              },
              color: 'bg-radial-ellipse-pink',
            },
            {
              position: {
                desktop: '-right-[5%] -top-[62%] h-[147%] w-[93%]',
                mobile: '-left-[93%] -top-[25%] h-[71%] w-[142%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: 'left-[6%] -bottom-[79%] h-[163%] w-[79%]',
                mobile: '-left-[37%] -bottom-[79%] h-[163%] w-[79%]',
              },
              color: 'bg-radial-ellipse-red',
            },
            {
              position: {
                desktop: '-bottom-[26%] -right-[44%] h-[120%] w-[89%]',
                mobile: 'bottom-[86%] -right-[11%] h-[120%] w-[122%]',
              },
              color: 'bg-radial-ellipse-red',
            },
          ],
        },
      ],
      blue: [
        {
          static: {
            position: '-bottom-[90%] -left-[92%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: '-bottom-[120%] -left-[101%] h-[200%] w-[150%]',
                mobile: '-top-[55%] -left-[61%] h-[100%] w-[125%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: 'bottom-[48%] left-[26%] h-[149%] w-[205%]',
                mobile: '-bottom-[48%] -left-[23%] h-[106%] w-[94%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-right-[114%] -bottom-[62%] h-[192%] w-[200%]',
                mobile: '-right-[49%] -bottom-[85%] h-[183%] w-[125%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: 'bottom-[22%] -right-[38%] h-[148%] w-[73%]',
                mobile: 'bottom-[22%] -right-[38%] h-[148%] w-[73%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
          ],
        },
        {
          static: {
            position: '-bottom-[90%] -left-[22%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: '-top-[161%] -left-[19%] h-[200%] w-[132%]',
                mobile: '-top-[36%] -right-[66%] h-[136%] w-[113%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-left-[67%] -bottom-[97%] h-[180%] w-[132%]',
                mobile: '-right-[20%] -bottom-[10%] h-[87%] w-[87%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: 'left-[15%] bottom-[29%] h-[178%] w-[200%]',
                mobile: '-right-[30%] -bottom-[71%] h-[138%] w-[159%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-bottom-[255%] -right-[37%] h-[303%] w-[166%]',
                mobile: '-bottom-[91%] -left-[94%] h-[124%] w-[135%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
          ],
        },
        {
          static: {
            position: '-bottom-[40%] -left-[32%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: '-top-[40%] -right-[152%] h-[200%] w-[200%]',
                mobile: 'top-[5%] -left-[56%] h-[100%] w-[118%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-left-[70%] -top-[69%] h-[144%] w-[149%]',
                mobile: '-right-[148%] -top-[99%] h-[150%] w-[200%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-left-[22%] -bottom-[126%] h-[200%] w-[72%]',
                mobile: '-left-[63%] -bottom-[71%] h-[103%] w-[117%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: 'top-[47%] -right-[19%] h-[157%] w-[121%]',
                mobile: 'top-[13%] -right-[68%] h-[157%] w-[155%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
          ],
        },
        {
          static: {
            position: '-bottom-[90%] -left-[92%] h-[206%] w-[238%]',
          },
          hover: [
            {
              position: {
                desktop: 'bottom-[9%] -left-[28%] h-[200%] w-[90%]',
                mobile: 'top-[18%] -left-[28%] h-[109%] w-[200%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: 'right-[15%] -top-[43%] h-[100%] w-[70%]',
                mobile: '-left-[93%] -top-[25%] h-[71%] w-[142%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-left-[34%] -bottom-[139%] h-[163%] w-[178%]',
                mobile: '-left-[37%] -bottom-[79%] h-[163%] w-[79%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
            {
              position: {
                desktop: '-bottom-[88%] -right-[141%] h-[200%] w-[200%]',
                mobile: 'bottom-[86%] -right-[11%] h-[120%] w-[122%]',
              },
              color: 'bg-radial-ellipse-azure',
            },
          ],
        },
      ],
    };

    const decorCircle = computed(() => {
      return variants[props.variant][props.index % 4];
    });

    return {
      isBiggerThanBreakpoint,
      decorCircle,
    };
  },
});
